/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the new value by (1 + the percentage as a decimal). If a price rose 20% to $60, divide 60 by 1.20 to get the original $50. This reverses the increase formula instead of applying it, and is useful when you only know the final price and the percentage applied.`)
};

const es_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide el valor nuevo entre (1 + el porcentaje como decimal). Si un precio subió un 20% hasta $60, divide 60 entre 1,20 para obtener el original de $50. Esto invierte la fórmula del aumento en lugar de aplicarla, y es útil cuando solo conoces el precio final y el porcentaje aplicado.`)
};

const de_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile den neuen Wert durch (1 + den Prozentsatz als Dezimalzahl). Ist ein Preis um 20% auf $60 gestiegen, teile 60 durch 1.20, um den ursprünglichen Preis von $50 zu erhalten. Das kehrt die Anstiegsformel um, statt sie anzuwenden, und ist nützlich, wenn du nur den Endpreis und den angewendeten Prozentsatz kennst.`)
};

const nl_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel de nieuwe waarde door (1 + het percentage als decimaal getal). Als een prijs met 20% steeg naar $60, deel je 60 door 1.20 om de oorspronkelijke $50 te krijgen. Dit keert de stijgingsformule om in plaats van hem toe te passen, en is nuttig wanneer je alleen de eindprijs en het toegepaste percentage kent.`)
};

const fr_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez la nouvelle valeur par (1 + le pourcentage en décimale). Si un prix a augmenté de 20 % pour atteindre 60 $, divisez 60 par 1,20 pour retrouver les 50 $ d’origine. Cela inverse la formule d’augmentation plutôt que de l’appliquer, et c’est utile quand vous ne connaissez que le prix final et le pourcentage appliqué.`)
};

const it_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi il nuovo valore per (1 + la percentuale come decimale). Se un prezzo è aumentato del 20% arrivando a $60, dividi 60 per 1.20 per ottenere l'originale $50. Questo inverte la formula dell'aumento invece di applicarla, ed è utile quando conosci solo il prezzo finale e la percentuale applicata.`)
};

const pt_br2_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o novo valor por (1 + a porcentagem em decimal). Se um preço subiu 20% para $60, divida 60 por 1.20 para obter os $50 originais. Isso reverte a fórmula do aumento em vez de aplicá-la, e é útil quando você só sabe o preço final e a porcentagem aplicada.`)
};

const pt_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o novo valor por (1 + a percentagem como decimal). Se um preço subiu 20% para $60, divida 60 por 1.20 para obter o original de $50. Isto inverte a fórmula do aumento em vez de a aplicar, e é útil quando só conhece o preço final e a percentagem aplicada.`)
};

const ja_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい値を(1 + 小数で表したパーセント)で割ります。価格が20%上昇して60ドルになった場合、60を1.20で割ると元の価格50ドルが求まります。これは増加の式を適用するのではなく逆算するもので、最終価格と適用されたパーセントしか分からない場合に役立ちます。`)
};

const zh_pct_increase_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用新值除以（1 + 化为小数的百分比）。如果价格上涨 20% 后变成 $60，用 60 除以 1.20 得到原价 $50。这是对增长公式做逆运算而非正向套用，当你只知道最终价格和所应用的百分比时非常有用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq4_a", locale)
	if (locale === "en") return en_pct_increase_faq4_a(inputs)
	if (locale === "es") return es_pct_increase_faq4_a(inputs)
	if (locale === "de") return de_pct_increase_faq4_a(inputs)
	if (locale === "nl") return nl_pct_increase_faq4_a(inputs)
	if (locale === "fr") return fr_pct_increase_faq4_a(inputs)
	if (locale === "it") return it_pct_increase_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq4_a(inputs)
	if (locale === "pt") return pt_pct_increase_faq4_a(inputs)
	if (locale === "ja") return ja_pct_increase_faq4_a(inputs)
	return zh_pct_increase_faq4_a(inputs)
};